export const GA4_EVENT_NAMES: Record<string, string> = {
  // Page views
  page_view: 'page_view',
  storefront_product_view: 'page_view',
  storefront_aggregation_view: 'page_view',
  toolkit_view: 'page_view',

  // Content
  content_view: 'content_view',

  // Product / ecommerce
  product_view: 'view_item',
  search_product_view: 'view_item',
  feed_product_view: 'view_item',
  aggregation_product_view: 'view_item',
  related_product_view: 'view_item',

  // Cart
  add_cart: 'add_to_cart',
  add_cart_first: 'add_to_cart',
  cart_view: 'view_cart',
  cart_checkout: 'begin_checkout',
  cart_remove: 'remove_from_cart',
  cart_remove_bundle: 'remove_from_cart',
  cart_update_event: 'add_to_cart',

  // Payment / purchase
  payment_checkout: 'add_payment_info',
  add_payment_info: 'add_payment_info',
  purchase_complete: 'purchase',
  purchase_button_complete: 'purchase',
  invoice_payment_complete: 'purchase',

  // Auth
  login_success: 'login',
  registration_success: 'sign_up',

  // Search
  search: 'search',
  view_search_results: 'view_search_results',
  search_correction: 'search',
  search_facet_update: 'search',
  feed_facet_update: 'search',

  // Navigation / interaction
  nav_click: 'navigation_click',
  header_click: 'header_click',
  footer_click: 'footer_click',
  event_click: 'event_click',
  cardClick: 'select_content',
  cardClick_search: 'select_content',
  external_link: 'external_link_click',
  download: 'file_download',

  // Prefs / engagement
  updated_prefs: 'preference_update',
  content_feedback: 'content_feedback',
  add_saved_item: 'add_to_wishlist',
  remove_saved_item: 'remove_from_wishlist',
  loadingFeed: 'feed_load',

  // Misc
  print: 'print',
  error: 'error',
  subscription_button_click: 'subscription_click',
};